import { registerWidgetShim } from "discourse/widgets/render-glimmer";
import { createTemplateFactory } from "@ember/template-factory";
registerWidgetShim("after-header-panel-outlet", "div.after-header-panel-outlet", createTemplateFactory(
/*
  <PluginOutlet @name="after-header-panel" @outletArgs={{hash topic=@data.topic}} /> 
*/
{
  "id": "vfGhKeCW",
  "block": "[[[8,[39,0],null,[[\"@name\",\"@outletArgs\"],[\"after-header-panel\",[28,[37,1],null,[[\"topic\"],[[30,1,[\"topic\"]]]]]]],null],[1,\" \"]],[\"@data\"],false,[\"plugin-outlet\",\"hash\"]]",
  "moduleName": "/var/www/discourse/app/assets/javascripts/discourse/node_modules/.embroider/rewritten-app/widgets/after-header-panel-outlet.js",
  "isStrictMode": false
}));